<template>
	<div class="report_detail_header">
		<headerCard
			:list="[
                {label:'报告周期：',value:`${$moment(detail.startTime).format('YYYY年M月')} (${$moment(detail.startTime).format('YYYY.M.D')}-${$moment(detail.endTime).format('YYYY.M.D')})`}
            ]"
		>
			<div class="header header_name"
				>{{detail.patientName}}·{{$status.gender[detail.patientSex]}}·{{detail.patientAge}}岁
			</div>
			<div class="header header_label">{{mainDiagnosisType}}</div>
		</headerCard>
	</div>
</template>
<script>
import headerCard from '../../form/components/form-header.vue'
export default {
    name: 'reportDetail',
    components: { headerCard },
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        mainDiagnosisType () {
            return this.detail.patientDetail && this.detail.patientDetail.questionnaireType === 1 ? this.detail.patientDetail.mainDiagnosis : '卒中风险人群'
        }
    }
}
</script>
<style lang="less" scoped>
.report_detail_header {
	.header {
		color: #ffffff;
		font-weight: bold;

		&_name {
			font-size: 36px;
			margin-bottom: 10px;
		}
		&_label {
			font-size: 30px;
			margin-bottom: 20px;
		}
	}
}
</style>